module.exports = __webpack_public_path__ + "img/lb4.c19da8e9.svg";